<obg-session-timer-container
	timerText="timer.session.text"
	*ngIf="isRegulatoryItemsSessionTimerVisible$ | async"
></obg-session-timer-container>
<time *ngIf="isRegulatoryItemsClockVisible$ | async">{{ time$ | async }}</time>
